/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { AccordionSection } from 'mapcontrols/components/subComponents';
import { BaseSelect, Loader, Picker } from 'ui-kit';
import moment from 'moment';
import apiData from '_entities/old/api/config';
import axios from 'axios';
import * as Styled from './styles';
import { isEmpty } from 'lodash';
import { CampaignEntity } from '_entities';
import { API_URLS } from '_constants';
import { notification } from 'utils/services';
import ExportDataDropDown from 'ui-kit/old/ExportDataDropDown';
import { useDispatch } from 'react-redux';

const { getMySecGeogsList } = CampaignEntity.actions;

const { baseUrl } = apiData;

const getAzReport = async (reportName, dateRange, params) => {
  const token = localStorage.getItem('Authorization');
  return axios.post(`${baseUrl}${API_URLS.azReport}/${reportName}${params}`, dateRange, {
    headers: {
      Authorization: `Token ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
};

const EXPORT_DATA_OPTIONS_NAMES = {
  DOWNLOAD: 'Download',
  EMAIL: 'Send to email',
};

const EXPORT_DATA_OPTIONS = [
  {
    label: 'Download',
    value: 'Download',
  },
  {
    label: 'Send to email',
    value: 'Send to email',
  },
];

const ReportAccordionSectionItem = ({
  title = '',
  id = '',
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeSections = {},
  onSectionToggle = () => {},
  text = '',
}) => {
  const [exportValue, setExportValue] = useState(null);
  const [countyOptions, setCountyOptions] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState({ label: 'All', value: '*' });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const isAGOCourtsDispo = id === 'ago-court-disposition';

  const loadCountyOptions = async () => {
    try {
      setIsLoading(true);
      const res = await dispatch(getMySecGeogsList());
      const parsedOptions = res?.data?.map((el) => ({
        id: el?.id,
        label: el?.attributes.name,
        name: el?.attributes.name?.toLowerCase(),
        value: el?.id,
        key: el?.attributes.name,
      }));
      setCountyOptions(parsedOptions);
    } catch (error) {
      console.log('getMySecGeogsList', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isAGOCourtsDispo) {
      loadCountyOptions();
    }
  }, []);

  const handleSelectCounty = (value) => {
    setSelectedCounty(value);
  };

  const handleStart = (date) => {
    setStartDate(date);
  };

  const handleEnd = (date) => {
    setEndDate(date);
  };

  const handleGenerateReport = async (params = '') => {
    try {
      setIsLoading(true);
      const start_date = moment(startDate).format('YYYY-MM-DD');
      const end_date = moment(endDate).format('YYYY-MM-DD');

      const res = await getAzReport(
        id,
        {
          start_date,
          end_date,
          ...(isAGOCourtsDispo && selectedCounty?.id && { sec_geog: selectedCounty?.id }),
        },
        params,
      );

      if (params && res.data) {
        try {
          const csvData = res.data;
          const contentDisposition = res?.headers['content-disposition'];
          let fileName = `${id}-${
            isAGOCourtsDispo ? selectedCounty?.name || 'all-counties' : ''
          }-${start_date}-${end_date}.csv`;
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+?)"/);
            if (match && match[1]) {
              fileName = match[1];
            }
          }

          const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('CSV download failed:', error);
        }
      }

      if (!params) {
        notification.success('The report has been successfully generated and sent to your email address');
      }
    } catch (err) {
      notification.error('Something went wrong during the request');
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportDataChange = ({ value }) => {
    setExportValue(value);
    switch (value) {
      case EXPORT_DATA_OPTIONS_NAMES.DOWNLOAD:
        handleGenerateReport('?export-format=csv');
        break;
      case EXPORT_DATA_OPTIONS_NAMES.EMAIL:
        handleGenerateReport();
        break;
      default:
    }
  };

  return (
    <Styled.AccordionWrapper>
      <AccordionSection
        title={title}
        id={id}
        activeSections={activeSections}
        onSectionToggle={onSectionToggle}
        collapsedArrowIcon={collapsedArrowIcon}
        expandedArrowIcon={expandedArrowIcon}
      >
        {isLoading && <Loader />}
        <Styled.ReportDescription>{text}</Styled.ReportDescription>
        {isAGOCourtsDispo && (
          <Styled.CountyOptionsWrapper>
            <BaseSelect
              name="county_ago_report"
              labelText="County"
              options={countyOptions}
              value={selectedCounty}
              onChange={(selectedValue) => handleSelectCounty(selectedValue)}
              inputId="county_ago_report"
              allowSelectAll
            />
          </Styled.CountyOptionsWrapper>
        )}
        <Styled.ReportActionWrapper>
          <Picker
            label="Start date (mm/dd/yyyy)*"
            showMonthYearDropdown
            idInput={`startDate-${id}`}
            onChange={(date) => handleStart(date)}
            selected={startDate || null}
            inputFor={`startDate-${id}`}
            name={`startDate-${id}`}
            menuPlacement="top"
            required
            closeOnScroll={true}
          />
          <Picker
            label="End date (mm/dd/yyyy)*"
            showMonthYearDropdown
            idInput={`endDate-${id}`}
            onChange={(date) => handleEnd(date)}
            selected={endDate || null}
            inputFor={`endDate-${id}`}
            name={`endDate-${id}`}
            menuPlacement="top"
            closeOnScroll={true}
            required
          />
          <ExportDataDropDown
            onChange={handleExportDataChange}
            value={exportValue}
            options={EXPORT_DATA_OPTIONS}
            placeholder={'Download/Email'}
            isDisabled={!startDate || !endDate || isLoading}
          />
        </Styled.ReportActionWrapper>
      </AccordionSection>
    </Styled.AccordionWrapper>
  );
};

export default ReportAccordionSectionItem;
